<script setup>

import { ref, watch, onMounted } from 'vue';

const { routine, selectionnee } = defineProps({
  routine: Object,
  selectionnee: Boolean
});

const composant = ref(null);

watch(() => selectionnee, (sel) => {
	if (sel) {
		composant.value.scrollIntoView({behavior: "smooth", block: "nearest"});
	}
});

onMounted(() => {
	if (composant.value != null && selectionnee) {
		composant.value.scrollIntoView({behavior: "smooth", block: "nearest"});
	}
});

</script>

<template>
	<div class="routine" 
		ref="composant">
		<div class="nom-routine">{{ routine.nom }}</div>
		<i v-if="routine.formuleEnErreur" class="fa-solid fa-triangle-exclamation icone erreur" v-tooltip="'Routine en erreur'" />
		<i v-else class="icone invisible" />
	</div>
</template>

<style scoped>

.routine {
	display: flex;
	user-select: none;
	padding: 0px 5px;
	align-items: center;
}

.nom-routine {
	width: 14rem;
	overflow: hidden;
	text-overflow: ellipsis;
	flex-grow: 1;
}

.icone {
	padding: 1px;
	margin: 2px 4px;
	width: 1rem;
	text-align: center;
}

.erreur {
	color: var(--couleur-valeur-en-erreur);
}

</style>